//----- Component --------------------------------------------------------/
// Developer :  Daiana Curcio
// Creation Date : 06/09/2024
// Version : 1
// Description : tabla de tareas para la info de tanque
//------Changes -------------------------------------------------------------//
// Change Date :
// Change by :
// Change description:
// Change Date :
// Change by :
// Change description:
//========================================================================/
import React, { useState, useEffect, useMemo } from "react";
import Typography from "@mui/material/Typography";
import { Box, Container, Tooltip } from "@mui/material";
import moment from "moment";
import { UrlApi } from "../../services/apirest";
import MaterialReactTable, {
  MRT_FullScreenToggleButton,
} from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es"; //Tabla en español
import { createTheme, ThemeProvider, useTheme } from "@mui/material";
import RepuestosTareas from "./RepuestosTareas";

function TablaTareas(props) {
  const [datosTanque, setDatosTanque] = useState(props.datosTanque);
  const [servicio, setServicio] = useState(props.servicio);
  const [tareasXtanque, setTareasXtanque] = useState();
  const [tabla, setTabla] = useState(true);
  const [confirmar, setConfirmar] = useState(false);
  const [notificacion, setNotificacion] = useState(false); //define si se muestra o no una notificación (snackbar)
  const [openSnack, setOpenSnack] = React.useState(false); //abre y cierra snack
  const [mensaje, setMensaje] = useState(""); //mensaje q mostrará la notif
  const [error, setError] = useState(null); //guardará el error que lance la api (si existe)

  const obtenerTareas = () => {
    fetch(
      UrlApi + "/tanque_tarea/tareaXtanqueYservicio/" + servicio.id_servicio
    )
      .then((data) => data.json())
      .then((data) => setTareasXtanque(data));
  };

  useEffect(() => {
    obtenerTareas();
  }, []);

  const columns = useMemo(
    () => [
      {
        header: "Desde",
        accessorFn: (desde) => moment(desde.tarea_desde).format("DD-MM-YYYY"),
        size: 55,
      },
      {
        header: "Hasta",
        accessorFn: (hasta) => moment(hasta.tarea_hasta).format("DD-MM-YYYY"),
        size: 55,
      },
      {
        header: "Motivo",
        accessorKey: "motivo_tarea",
        size: 200,
        Cell: ({ cell }) => (
          <Tooltip
            title={
              <span style={{ whiteSpace: "pre-wrap" }}>{cell.getValue()}</span>
            }
            arrow
            placement="top-start"
            enterDelay={300}
            leaveDelay={200}
            PopperProps={{
              modifiers: [
                {
                  name: "offset",
                  options: {
                    offset: [0, 8],
                  },
                },
              ],
            }}
            slotProps={{
              tooltip: {
                sx: {
                  maxWidth: 700,
                  bgcolor: "rgb(181,181,179,0.95)",
                  color: "black",
                  fontSize: "1rem",
                  p: 2.5,
                  borderRadius: 2,
                },
              },
            }}
          >
            <div
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: 300,
                cursor: "help",
              }}
            >
              {cell.getValue()}
            </div>
          </Tooltip>
        ),
      },
      {
        header: "Detalle",
        accessorKey: "detalle_tarea",
        size: 310,
        Cell: ({ cell }) => (
          <Tooltip
            title={
              <span style={{ whiteSpace: "pre-wrap" }}>{cell.getValue()}</span>
            }
            arrow
            placement="top-start"
            enterDelay={300}
            leaveDelay={200}
            PopperProps={{
              modifiers: [
                {
                  name: "offset",
                  options: {
                    offset: [0, 8],
                  },
                },
              ],
            }}
            slotProps={{
              tooltip: {
                sx: {
                  maxWidth: 700,
                  bgcolor: "rgb(181,181,179,0.95)",
                  color: "black",
                  fontSize: "1rem",
                  p: 2.5,
                  borderRadius: 2,
                },
              },
            }}
          >
            <div
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: 300,
                cursor: "help",
              }}
            >
              {cell.getValue()}
            </div>
          </Tooltip>
        ),
      },
      { header: "A cargo de", accessorKey: "razon_social", size: 150 },
      {
        header: "Finalizada",
        accessorKey: "estado_palabra_finalizada",
        size: 50,
      },
      {
        header: "Es",
        accessorKey: "estado_palabra_proviene",
        size: 55,
      },
    ],
    []
  );
  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
    variant: "outlined",
    color: "success",
    size: "small",
  };
  const globalTheme = useTheme();
  const tableTheme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: globalTheme.palette.mode, //let's use the same dark/light mode as the global theme
          primary: globalTheme.palette.primary, //primary color for the table
          info: {
            main: "rgb(255,122,0)", //add in a custom color for the toolbar alert background stuff
          },
          background: {
            default:
              globalTheme.palette.mode === "light"
                ? "rgb(234, 239, 241)" //background in light mode
                : "#000", //pure black table in dark mode for fun
          },
        },
        typography: {
          button: {
            textTransform: "none", //customize typography styles for all buttons in table by default
            fontSize: "1.2rem",
          },
        },
        components: {
          MuiTooltip: {
            styleOverrides: {
              tooltip: {
                fontSize: "1.1rem", //override to make tooltip font size larger
              },
            },
          },
        },
      }),
    [globalTheme]
  );
  const initialState = {
    //para inicializar la tabla, y la cantidad de paginas q se ven ej 5
    density: "compact",
    showGlobalFilter: true,
    pagination: { pageIndex: 0, pageSize: 5 },
    // sorting: [
    //     {
    //       id: 'tarea_desde',
    //       desc: true,
    //     },
    //   ],
  };
  const tableHeadCellProps = {
    align: "left",
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
    },
  };

  const customLocalization = {
    ...MRT_Localization_ES,
    expandAll: "Ex", // Cambia 'Expandir todo' a 'Ex'
    expand: "Ex", // Cambia 'Expandir' a 'Ex'
  };

  return (
    <div>
      <Container maxWidth={false} disableGutters sx={{ mt: 1, mb: 2 }}>
        {tareasXtanque && tabla ? (
          <Box mt={2} boxShadow={3}>
            <ThemeProvider theme={tableTheme}>
              <MaterialReactTable
                enableColumnResizing
                enableExpandAll={false}
                muiTableHeadCellProps={tableHeadCellProps}
                enableToolbarInternalActions={true} //las acciones al lado del search (agregar y full screen)
                enableGrouping // para permitir agrupar x estado x ej
                layoutMode="grid"
                muiTableBodyCellProps={{
                  align: "left", //el contenido de la tabla
                }}
                enableColumnActions={true} //los puntitos de al lado de los titulos (acciones) -> hay que activarlo para agrupar x estado x ej
                enableColumnFilters={false} //desactiva filtros x  columna
                enableHiding={false} // opcion de ocultar columna pero activando el enablecolumaction
                enableDensityToggle={false} //
                localization={customLocalization} //idioma
                enableColumnDragging={false} //para arrastrar columnas
                initialState={initialState}
                muiSearchTextFieldProps={muiSearchTextFieldProps}
                columns={columns}
                data={tareasXtanque} //con lo q la completas (esto cambia siempre)
                enableStickyFooter
                enableSorting={true}
                //enableEditing
                //  enableRowActions
                //  positionActionsColumn="last" // posicion de la columna de acciones al final
                // ACCIONES
                renderTopToolbarCustomActions={() => (
                  <>
                    <Typography variant="poster" fontSize={22}>
                      Tareas del servicio
                    </Typography>
                  </>
                )}
                renderToolbarInternalActions={(
                  { table } // boton para nuevo , al lado del buscar
                ) => (
                  <>
                    <MRT_FullScreenToggleButton table={table} />
                  </>
                )}
                renderDetailPanel={({ row }) => (
                  <div style={{ marginTop: "-50px" }}>
                    <Box
                      sx={{
                        width: "200%",
                      }}
                    >
                      <RepuestosTareas tareasXtanque={row.original} />
                    </Box>
                  </div>
                )}
              />
            </ThemeProvider>
            <br />
          </Box>
        ) : null}
      </Container>
    </div>
  );
}

export default TablaTareas;
